export const DEEPLINK_ONLY_PAGES_NAMES = [
  'path-without-handling',
  'appointments-id-creation',
  'chat-doctor-payment-wait',
]
